/* tslint:disable */

declare var Object: any;
export interface AccessoryPictureInterface {
  "name": string;
  "displayName": string;
  "required": boolean;
  "id"?: any;
}

export class AccessoryPicture implements AccessoryPictureInterface {
  "name": string;
  "displayName": string;
  "required": boolean;
  "id": any;
  constructor(data?: AccessoryPictureInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AccessoryPicture`.
   */
  public static getModelName() {
    return "AccessoryPicture";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AccessoryPicture for dynamic purposes.
  **/
  public static factory(data: AccessoryPictureInterface): AccessoryPicture{
    return new AccessoryPicture(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AccessoryPicture',
      plural: 'AccessoryPictures',
      path: 'AccessoryPictures',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "displayName": {
          name: 'displayName',
          type: 'string'
        },
        "required": {
          name: 'required',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
